import { range } from 'lodash-es';
import type { BlotterType } from 'models/blotters/BlotterType';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

interface SkeletonProps {
  buttonsCount: number;
  documentsCount: number;
}

const StyledComponentContainer = styled.div`
  .buttons-container {
    & > button {
      flex-basis: 45%;

      &:first-child:last-child,
      &:nth-child(odd):last-child {
        flex-basis: 100%;
      }

      &.trade-cancellation-button {
        flex-basis: auto;
      }
    }
  }
`;
export const PanelFooterSkeleton: FC<SkeletonProps> = ({ buttonsCount, documentsCount }) => (
  <StyledComponentContainer className="card-footer container sc-cMhqgX eOdNsd" data-e2e="blotter-panel-footer-skeleton">
    {documentsCount > 0 && (
      <div className="card w-100">
        <div className="card-body p-0 flex-wrap mt-3">
          <ul className="list-group list-group-flush">
            {range(0, documentsCount).map(docIndex => (
              <li key={docIndex} className="list-group-item border d-flex py-1 px-2">
                <div className="d-flex align-items-center me-auto text-secondary">
                  <i className="icon icon-sm me-2">
                    <Skeleton width="1em" />
                  </i>
                  <Skeleton width="10em" />
                </div>
                <button className="btn btn-sm d-flex flex-row align-items-center justify-content-center px-2">
                  <Skeleton width="2em" className="mx-1" />
                  <Skeleton width="2em" className="mx-1" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )}
    <div className="card buttons-container mt-3 flex-row flex-wrap gap-1">
      {range(0, buttonsCount).map(btnIndex => (
        <button key={btnIndex} className="btn btn-xl btn-discreet-primary flex-grow-1 btn-icon-start" type="button">
          <span>&nbsp;</span>
        </button>
      ))}
    </div>
  </StyledComponentContainer>
);

export const BlotterPanelFooterSkeleton: FC<{ blotterType: BlotterType }> = ({ blotterType }) => {
  switch (blotterType) {
    case 'quotes':
      return <PanelFooterSkeleton documentsCount={2} buttonsCount={3} />;
    case 'trades':
      return <PanelFooterSkeleton documentsCount={3} buttonsCount={1} />;
    case 'products':
      return <PanelFooterSkeleton documentsCount={1} buttonsCount={2} />;
    default:
      return null;
  }
};
